import axios from '../requester';
import { API } from '../constants/api-urls';

export const getPullRequestsSearchSummary = async (
  requests,
  isSearchReleasesV2Enabled = false
) =>
  axios
    .post(`${API.PRS_PATH}/search/summary`, {
      requests,
      isSearchReleasesV2Enabled
    })
    .then(({ responses }) => responses);

export const getPullRequests = async params =>
  axios.post(`${API.PRS_PATH}/search`, {
    ...params,
    resolve_containers: true,
    avoid_fetching_teams: true,
    fetch_contributor_columns: false
  });

export const getPullRequestsLabels = async () =>
  axios.get(`${API.PRS_PATH}/labels`);
